export default {
    error: {
        generic:
            "Este segmento parou de ser atualizado. Entre em contato com o suporte se o problema continuar.",
        points_program_inactive:
            "Este segmento parou de ser atualizado porque usa saldo de pontos como condição, e o programa de pontos está desativado. Reative o programa ou remova essa condição para voltar a atualizá-lo.",
        short: {
            generic: "Atualização pausada.",
            points_program_inactive: "Atualização pausada: programa de pontos desativado.",
        },
    },
    create_modal: {
        title: "Criar Segmento",
        label: "Por favor, escreva o nome do segmento",
        loading: "Criando segmento, isso pode levar alguns instantes...",
        cancel: "Cancelar",
        create: "Criar",
        trigger: "Criar Segmento",
        success: "Segmento criado com sucesso!",
        internal_error: "Erro interno no servidor, tente novamente mais tarde!",
    },
    list: {
        delete_title: "Deseja deletar esse segmento?",
        delete_body:
            "Essa ação é irreversível e irá deletar permanentemente esse segmento e todos os dados a ele vinculados.",
        title: "Segmentos de clientes",
        add_button: "Adicionar",
        add_aria: "Adicionar segmento",
        search_placeholder: "Buscar segmento por nome...",
        search_aria: "Buscar segmento por nome",
        max_reached_prefix: "Você atingiu o máximo de",
        max_reached_suffix: "formulários",
        segment_contacts_tooltip: "Ver contatos deste segmento",
        last_30_days: "Movimentações nos últimos 30 dias",
        joined: "Entraram:",
        left: "Saíram:",
        clients: "clientes",
        edit: "Editar",
        delete: "Excluir",
        edit_segment_aria: "Editar segmento {0}",
        delete_segment_aria: "Deletar segmento {0}",
        deleted_success: "Segmento deletado",
        delete_in_use_by_tier: "Este segmento é usado pelo nível {name}. Para excluí-lo, exclua o nível antes na Central de Benefícios.",
        delete_error: "Não foi possível excluir o segmento.",
        manual_badge: "Manual",
        dynamic_badge: "Dinâmico",
        manage_members: "Gerenciar membros",
        manage_members_aria: "Gerenciar membros do segmento {0}",
        add_members: "Adicionar membros",
        remove_members: "Remover membros",
        columns_name: "Nome",
        columns_type: "Tipo",
        columns_clients: "Clientes",
        columns_movements: "Movimentações",
        columns_actions: "Ações",
        columns_created_at: "Criado em",
        filters_type: "Tipo",
        filters_created_period: "Data de criação",
    },
    members: {
        modal_add_title: "Adicionar membros ao segmento",
        modal_remove_title: "Remover membros do segmento",
        title: "Gerenciar membros do segmento",
        back: "Voltar aos segmentos",
        add_button: "Adicionar clientes filtrados",
        remove_button: "Remover clientes filtrados",
        confirm_add_title: "Adicionar clientes ao segmento?",
        confirm_add_body: "Isso adicionará {0} clientes filtrados a este segmento.",
        confirm_remove_title: "Remover clientes do segmento?",
        confirm_remove_body: "Isso removerá {0} clientes filtrados deste segmento.",
        add_success: "{0} clientes adicionados ({1} já estavam no segmento).",
        remove_success: "{0} clientes removidos ({1} não estavam no segmento).",
        saving_add: "Adicionando clientes ao segmento...",
        saving_remove: "Removendo clientes do segmento...",
        saving_hint: "Isso pode levar alguns instantes para públicos grandes.",
        dynamic_error: "Apenas segmentos manuais permitem gerenciamento de membros.",
        error: "Não foi possível atualizar os membros do segmento.",
    },
    form: {
        add_title: "Adicionar segmento",
        name_helper: "Escolha um nome para identificar seu segmento",
        name_placeholder: "Nome do segmento",
        update_daily: "Atualizar diariamente?",
        type_help: "Segmentos dinâmicos recalculam a membros diariamente. Segmentos manuais mantêm uma lista fixa de clientes.",
        manual_populate_label: "Como este segmento manual deve começar?",
        start_empty: "Começar vazio",
        populate_from_filters: "Popular a partir de filtros",
        yes: "Sim",
        no: "Não",
        audience: "Público:",
        ai_placeholder:
            "Quem está a 90 dias sem comprar e tem duas compras ou mais",
        ai_filter: "Filtrar",
        ai_use: "Usar IA",
        ai_error_prefix:
            "Não foi possível gerar filtros exatos para esta descrição.",
        ai_error_hint: "Talvez você queira:",
        loading_sentences: {
            s1: "Analisando os filtros disponíveis...",
            s2: "Identificando os melhores critérios...",
            s3: "Processando dados dos clientes...",
            s4: "Selecionando algoritmos de segmentação...",
            s5: "Refinando os parâmetros...",
            s6: "Ainda processando, isso pode demorar um pouco...",
            s7: "Sua paciência será recompensada...",
            s8: "Finalizando os últimos detalhes...",
            s9: "Sério, está quase pronto...",
            s10: "Só mais um minutinho...",
            s11: "Não desista, já chegamos lá...",
        },
        empty_state: "Adicione filtros ou grupos para criar sua condição",
        calculating_target: "Calculando público-alvo...",
        save: "Salvar",
        updating: "Atualizando...",
        creating: "Criando...",
        filters_generated_success: "Filtros gerados com sucesso!",
        filters_generated_error: "Erro ao gerar filtros. Tente novamente.",
        server_error_prefix: "Erro ao comunicar com o servidor:",
        save_error_log: "Erro ao salvar segmento:",
        invalid_filters_log: "Filtros inválidos recebidos:",
    },
    filters: {
        orders_count: "Número de pedidos",
        quotations_count: "Número de orçamentos",
        quotations_amount: "Valor de orçamentos",
        rfm_group: "Grupo RFM",
        campaign_interactions: "Interações de Campanha",
        days_after_field: "Dias após {0}",
        custom_event: "Evento Personalizado",
        purchased_product: "Comprou produto",
        filled_form: "Respondeu um formulário",
        customer_profile: "Perfil do cliente",
        profile_complete: "Com cadastro completo",
        profile_incomplete: "Sem cadastro completo",
        profile_with_phone: "Com telefone",
        profile_with_email: "Com e-mail",
        points_balance: "Saldo de Pontos",
        average_ticket: "Ticket médio",
        clv_total_spent: "Gasto acumulado (CLV)",
        branches: "Filiais",
        days_since_last_order: "Dias desde o último pedido",
        days_since_first_order: "Dias desde o primeiro pedido",
        days_until_next_order: "Dias previstos até próximo pedido",
        days_since_created: "Dias desde o cadastro",
        age: "Idade",
        birthday_month: "Aniversariantes do Mês",
        communication_channels: "Canais de Comunicação",
        accepted: "Aceito",
        and: "e",
        between: "entre",
        birthdays_of_month: "Aniversariantes do mês",
        close: "Fechar",
        conditions_count: "{count} condição(ões) de resposta",
        days_ago: "dias atrás",
        event: "Evento",
        form: "Formulário",
        no_questions: "Este formulário não possui perguntas para filtrar.",
        question_conditions: "Respostas das perguntas (opcional)",
        select_form: "Selecione um formulário",
        which_form: "Qual formulário",
        executions: "Execuções",
        from: "de",
        indifferent: "Indiferente",
        inform_values: "Informar valores",
        limit_by_values: "Limitar por valores",
        limit_time_range: "Limitar período de tempo",
        more_than: "mais que",
        not_accepted: "Não aceito",
        period_label: "Período",
        purchase_quantity: "Quantidade de compras",
        purchases: "Compras",
        search_combined_info: "Buscar informações combinadas",
        search_event: "Buscar evento",
        select_values: "Selecionar valores",
        until: "até",
        which_brand: "Qual marca",
        which_category: "Qual categoria", 
        which_event: "Qual evento",
        which_product: "Qual produto",
        which_status_to_execute: "Qual status para executar",
        order_custom_fields: "Campos personalizados do pedido",
        op_starts_with: "Começa com",
        op_date_on: "Em",
        op_date_after: "Depois de",
        op_date_before: "Antes de",
        select_operator: "Selecionar operador",
        select_date: "Selecionar data",
        enter_value: "Informar valor",
        add_custom_field: "Adicionar campo personalizado...",
        no_custom_fields_added: "Nenhum campo personalizado adicionado.",
        remove_custom_field: "Remover campo",
    },
};
